import { sendEvent } from '../lib/tools';

export default class SiteHeader {
  init() {
    this.outlets.menuButton.addEventListener('click', () => {
      sendEvent('site-mobile-menu__invoke');
    });
  
    this.outlets.searchButton.forEach((button) => {
      button.addEventListener('click', () => {
        sendEvent('site-search__invoke');
      });
    });

    window.addEventListener('scroll', () => {
      this.scroll();
    });
    
    this.scroll();
  }

  scroll() {
    if (window.scrollY > 0) {
      this.node.classList.add('state-shrink');
    } else {
      this.node.classList.remove('state-shrink');
    }
  }

}
